<div class="inner">
  <div class="logo"><img src="assets/logo.png" alt="logo" /></div>
  <ul class="categoryList" *ngIf="!isApiLoading; else loading">
    <li class="categoryItem" (click)="changeCategory('all')">
      <span class="icon"></span>
      全部
      <span class="chevron right"></span>
    </li>
    <li
      class="categoryItem"
      (click)="changeCategory(item.catType.type_name)"
      *ngFor="let item of categoryList"
    >
      <span class="icon"></span>
      {{ item.catType.type_name }}
      <span class="chevron right"></span>
    </li>
  </ul>
  <div class="menu-toggle" (click)="menuToggle()">
    <img class="toggle-icon" src="assets/menu-toggle.svg" alt="" />
  </div>
</div>
<ng-template #loading>
  <app-loading [isLoading]="isApiLoading"></app-loading>
</ng-template>
